import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { AddBandsService } from "../../../_services/brand/add-bands.service";

@Component({
  selector: "app-add-brands",
  templateUrl: "./add-brands.component.html",
  styleUrls: ["./add-brands.component.css"],
  providers: [AddBandsService]
})
export class AddBrandsComponent implements OnInit {
  model: any = {};
  data = <any>{};
  allbrands: any;
  getallbrands: any;
  constructor(
    private addbrandservice: AddBandsService,
    private Router: Router
  ) {
    this.addbrandservice.getServiceProviderType().subscribe(res => {
      this.allbrands = res;
    });
  }

  ngOnInit() {}

  @ViewChild("submit_brand") submit_brand: ElementRef;
  addbrand() {
    this.submit_brand.nativeElement.disabled = true;
    this.addbrandservice.savebrands(this.data).subscribe(res => {
      window.location.reload();
    });
  }
}



// WEBPACK FOOTER //
// C:/wamp64/www/duetz.repos/angular4/src/app/_components/brands/add-brands/add-brands.component.ts